// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:58:44

export default {
  "id": "office-escape-to-date",
  "slug": "office-escape-to-date",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/82c50c194c6446c2b2f09ff5d62dd2c8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/82c50c194c6446c2b2f09ff5d62dd2c8/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Office Escape to Date",
      "description": "You have a date after work, but theres a catch: you need to get ready without your boss catching you! Complete your tasks, and prepare for your date before time runs out. But be careful, if the boss appears, quickly close the activity to avoid getting caught and return to work. How fast can you escape the office and be ready in time?",
      "instructions": "Mouse Only",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "avoid",
        "boss",
        "girls",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "办公室逃爱记",
      "description": "你下班后有约会，但有个难题：你不能让老板发现你在做准备！完成你的任务，在时间耗尽前为约会做好准备。但要注意，如果老板出现，要迅速关闭活动以避免被发现，然后返回工作。你能多快逃离办公室并及时准备好？",
      "instructions": "仅鼠标操作",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "躲避",
        "Boss",
        "女孩",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "辦公室逃離之約會",
      "description": "您下班後有一場約會，但有一個問題：您需要在老闆沒發現的情況下準備好！完成您的任務，並在時間耗盡前準備好約會。但請小心，如果老闆出現，請迅速關閉活動以避免被發現，並返回工作。您能多快逃離辦公室並準時準備好？",
      "instructions": "僅使用滑鼠",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "避免",
        "BOSS",
        "女孩",
        "消磨時間"
      ]
    },
    "zh-HK": {
      "title": "辦公室逃亡約會之旅",
      "description": "你下班後有一個約會，但問題是：你需要在老闆沒發現的情況下準備好！完成你的任務，並在時間耗盡前準備好約會。但請小心，如果老闆出現，請迅速關閉活動以避免被發現並返回工作。你能多快逃離辦公室並準時準備好？",
      "instructions": "鼠標操作",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "避開",
        "大頭目",
        "少女",
        "消磨時間工具"
      ]
    },
    "ja": {
      "title": "オフィス脱出デート",
      "description": "仕事が終わった後、デートがありますが、問題があります：上司に見つかってはいけません！タスクを完了し、デートの準備をしておく前に時間が切れないよう注意してください。しかし、注意してください、上司が現れたら、見つかってしまうのを避けるためにアクティビティを速やかに閉じ、仕事に戻ってください。オフィスから逃げ出して時間に間に合うまでどれだけ早くできるでしょうか？",
      "instructions": "マウスのみ",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ボス避け",
        "ガールズ",
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "오피스 익스케이프 투 데이트",
      "description": "일하신 후에 만남이 있었는데, 단서가 있습니다: 직장장이 당신을 잡지 않도록 준비를 해야 합니다! 임무를 완료하고, 만남 준비를 마쳐 시간이 지기 전에 해결해야 합니다. 하지만 주의하세요, 직장장이 나타나면, 잡힐 수 없도록 활동을 빨리 닫고 일로 돌아가세요. 사무실을 빠르게 탈출하고 시간에 맞춰 준비할 수 있을까요?",
      "instructions": "마우스 전용",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "회피",
        "보스",
        "소녀",
        "시간죽이미자"
      ]
    },
    "fr": {
      "title": "Échappée d'Office pour une Rendez-vous",
      "description": "Vous avez un rendez-vous après le travail, mais voilà un problème : vous devez vous préparer sans que votre patron ne vous catches! Terminez vos tâches et préparez-vous pour votre rendez-vous avant que le temps ne se termine. Mais soyez prudent, si votre patron apparaît, fermez rapidement l'activité pour éviter d'être catché et retournez au travail. Combien de temps faudra-t-il pour échapper au bureau et être prêt à temps ?",
      "instructions": "Souris seule",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "éviter",
        "boss",
        "filles",
        "tempspigeon"
      ]
    }
  }
};
